export const I18nNoop = (i18nValue: any) => i18nValue.value || i18nValue;
